<template>
  <div class="page-login">
    <div class="page-login-main">
      <div class="page-title">
        <div class="logo-img">
          <img src="../images/login/bg-logo@2x.png" alt="" />
        </div>
        <p class="inline-block paddingL20">账号密码登录</p>
      </div>
      <div class="form-input">
        <div class="van-hairline--bottom">
          <van-field
            class="input-item"
            v-model="formData.username"
            :border="false"
            @focus="inputFocus('focusA')"
            @blur="inputBlur('focusA')"
            placeholder="请输入账号/手机号码"
            clearable
          />
          <div class="input-under-line" :class="{ active: focusA }"></div>
        </div>
        <div class="van-hairline--bottom">
          <van-field
            class="input-item"
            v-model="formData.password"
            :type="showPassword ? 'text' : 'password'"
            :border="false"
            @focus="inputFocus('focusB')"
            @blur="inputBlur('focusB')"
            placeholder="请输入密码"
            clearable
          >
            <span @click="switchShowPassword" slot="button">
              <van-icon
                class="right-btn"
                :name="showPassword ? 'eye-o' : 'closed-eye'"
              />
            </span>
          </van-field>
          <div class="input-under-line" :class="{ active: focusB }"></div>
        </div>
      </div>
      <div class="login-btn cursor-pointer" @click="doLogin">登录</div>
    </div>
  </div>
</template>

<script>
import { Field, CellGroup, Icon } from "vant";

export default {
  components: {
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [Icon.name]: Icon,
  },
  data() {
    return {
      loading: false,
      loadingVerify: false,
      showPassword: false,
      formData: {
        grant_type: "password",
        scope: "server",
        username: "",
        password: "",
      },
      verifyImage: "",
      focusA: false,
      focusB: false,
    };
  },
  created() {
    // 进入登录页面先清空个人信息
  },
  methods: {
    /**
     * 登陆完跳转
     */
    redirectFn() {
      if (this.fromUrl) {
        this.$router.push(this.fromUrl);
      } else {
        this.goBeforeLoginUrl();
      }
    },
    inputFocus(str) {
      this[str] = true;
    },
    inputBlur(str) {
      this[str] = false;
    },
    switchShowPassword() {
      this.showPassword = !this.showPassword;
    },
    /**
			 /**
			 登陆
			 */
    doLogin() {
      if (!this.formData.username || !this.formData.password) {
        this.$Toast.fail(
          !this.formData.username ? "账号不能为空" : "密码不能为空"
        );
        return;
      }
      // 验证成功
      this.$Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
      });

      let formData = { ...this.formData };
      formData.password = this.AES.Encrypt(formData.password);
      this.$store.dispatch("doLogin", formData).then(() => {
        this.$Toast.clear();
        if (this.$route.query.from) {
          this.$router.push(this.$route.query.from);
        } else {
          this.goBeforeLoginUrl();
        }
      });
    },
    mousedownPassword() {
      this.inputType = "text";
    },
    mousedownText() {
      this.inputType = "password";
    },
    mouseup() {
      this.inputType = "password";
    },
  },
};
</script>
<style lang="scss" scoped>
.page-login {
  height: 100%;
  background: white;
  .page-login-main {
    width: 100%;
    position: relative;
    z-index: 10;
    padding: 137px 0 0;
  }
  .login-bg {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: auto;
    z-index: 1;
    .img {
      display: block;
      width: 100%;
    }
  }
}

.page-title {
  font-size: 48px;
  font-family: PingFang-SC-Bold;
  font-weight: bold;
  color: rgba(67, 69, 64, 1);
  line-height: 64px;
  padding: 0 60px;
}

.logo-img {
  display: inline-block;
  width: 88px;
  height: 110px;
}

.form-input {
  font-size: 32px;
  padding: 20px 60px 0;
  .input-item {
    padding: 30px 0;
    margin-top: 40px;
    position: relative;
  }
}

.input-under-line {
  height: 1px;
  width: 0;
  position: relative;
  text-align: center;
  margin: 0 auto -1px;
  background: $primary;
  transition: all 0.28s;
  &.active {
    width: 100%;
  }
}

.login-btn {
  max-width: 654px;
  width: 95%;
  height: 88px;
  line-height: 88px;
  font-size: 36px;
  background: #ccc;
  margin: 190px auto 0;
  border-radius: 44px;
  text-align: center;
  color: white;
  transition: all 0.28s;
  &:active {
    background: #dcdcdc;
  }
}

.right-btn {
  font-size: 48px;
  z-index: 100;
}

.page-login {
  background: url("../images/login/login_bg@2x.png") no-repeat 0 0 white;
  background-size: cover;
}
</style>
<style lang="scss"></style>
